// import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import WelcomeScreen from "./Pages/SplashScreens/WelcomeScreen";
import PhoneNumber from "./Pages/PhoneNumber";
import PanNumber from "./Pages/PanNumber";
import VerifyOtp from "./Pages/VerfiyOtp";
import KycProcess from "./Pages/Kyc_Process";
import HoldInvestment from "../src/Pages/BasicsQue/HoldInvestment";
import ResidentialStatus from "../src/Pages/BasicsQue/ResidentialStatus";
import InvesmentProfile from "../src/Pages/BasicsQue/Invesment_profile";
import Portfolio from "../src/Pages/BasicsQue/Portfolio";
import StartKycHome from "./Pages/StartKycHome";
import KycRejected from "./Pages/KycRejected";
import SecondSplash from "./Pages/SplashScreens/SplashSecondScreen";
import ThirdSplash from "./Pages/SplashScreens/SplashThrid";
import FourSplash from "./Pages/SplashScreens/SplashFour";
import DextersScanning from "./Pages/ScanningLotties/DextersScanning";
import DextersScanning2 from "./Pages/ScanningLotties/DexterScanning2";
import DextersScanning3 from "./Pages/ScanningLotties/DexterScanning3";
// import DextersScanning4 from "./Pages/ScanningLotties/DexterrScanning4";
import AccountNo from "./Pages/KYCScreens/AccountNo";
// import IfscCode from "./Pages/KYCScreens/IFSC";
// import DepositeMoney from "./Pages/KYCScreens/DepositeMoney";
import Email from "./Pages/EmailScreen";
// import Email1 from "./Pages/EmailScreen1";
import Bank from "./Pages/BankScreen";
import NomineeDetails from "./Pages/NomineeDetails";
import NomineeGuardian from "./Pages/NomineeGuardian";
import NomineeVerification from "./Pages/NomineeVerification";
import Checkboxes from "./Pages/ThreeCheckboxes";
import AccountType from "./Pages/AccountType";
import Occupation from "./Pages/Occupation";
import PlaceofBirth from "./Pages/PlaceofBirth";
// import CapturePhoto from "./Pages/KYCScreens/CapturePhoto";
// import CaptureSignature from "./Pages/KYCScreens/CaptureSignature";
// import CaptureLocation from "./Pages/KYCScreens/CaptureLocation";
// import PersonalDetails from "./Pages/PersonalDetails";
// import RecommendedPortfolios from "./Pages/PortfolioScreen/RecommendedPortfolios";
import UpdatedPortFolio from "./Pages/PortfolioScreen/UpdatedPortFolio";
import PurchaseOneTime from "./Pages/Sip Screens/PurchaseOneTime";
import Confirmation from "./Pages/Sip Screens/Confirmation";
import PurchaseVerifyOtp from "./Pages/Sip Screens/PurchaseVerifyOtp";
import FinanciallyDepended from "../src/Pages/BasicsQue/Depended";
import CancelledCheque from "./Pages/KYCScreens/CancelledCheque";
import PurchasePhoneNumber from "./Pages/Sip Screens/PurchaseSendOtp";
import NomineePhoneNumber from "./Pages/NomineeSendOtp";
import DextersScanning5 from "./Pages/ScanningLotties/DexterrScanning5";
import { Suspense } from "react";
import Lauyout from "./Components/layout";
import ProtectedLayout from "./Components/layout/ProtectedLayout";
import GenderDob from "./Pages/PortfolioScreen/genderDob";
import AddressLine from "./Pages/PortfolioScreen/AddressLine";
import StatePincode from "./Pages/PortfolioScreen/StatePincode";
import BlankText from "./Pages/MassagesScreens/BlankText";
import CustomerSupportScreen from "./Pages/MassagesScreens/CustomerSupportScreen";
import DeactivatedScreen from "./Pages/MassagesScreens/deactivatedScreen";
import FATCAConfirmation from "./Pages/MassagesScreens/FATCAConfirmation";
import SIPConfirmationLink from "./Pages/MassagesScreens/SIPConfirmationLink";
import AchEmandateStatus from "./Pages/ScanningLotties/AchEmandateStatus";
import FatcaFailed from "./Pages/MassagesScreens/FatcaFailed";
import BankMessagescreen from "./Pages/MassagesScreens/BankMessagescreen";
import WelcomePage from "./Pages/SplashScreens/WelcomePage";
import NSeConfirmationWaiting from "./Pages/MassagesScreens/NseWaiting";
import Account_Conflict_Message from "./Pages/MassagesScreens/Account_Conflict_Message";
// import AudioPlayer from "./Pages/AudioHighlight";
// import AudioHighlight from "./Pages/AudioHighlight";
import DexterrAudioLottieAnimation from "./Components/Animation/DexterAudios"
import TaxIdNumber from "./Pages/NRIScreens/NriTaxIdnumber";
import AddesssNRI from "./Pages//NRIScreens/AddesssNRI";
import PincodeNRI from "./Pages/NRIScreens/PincodeNRI";
import TaxResidencyNRI from "./Pages/NRIScreens/TaxResidencyNRI";
import BankProofSubmitted from "./Pages/MassagesScreens/BankProofSubmitted";

// export const WELCOME = "/";
export const Dexter_Splash2 = "/dexterr-explains-welcome";
export const Dexter_Splash3 = "/dexterr-investment-welcome";
export const Dexter_Splash4 = "/dexterr-basic-questions";
export const ROUTE_MOBILE_VERIFICATION = "/dexterr-phone-number";
export const ROUTE_OTP_VERIFICATION = "/dexterr-phone-number-otp";
export const ROUTE_Dexterr_Ach_Emandate_Status = "/dexterr-ach-emandate-status";
export const ROUTE_DEXTER_SCANNING3 = "/dexterr-payment-status";
export const ROUTE_UPLOAD_CANCELLED_CHEQUE = "/dexterr-upload-cancelled-cheque";
export const ROUTE_Bank_Proof_Submitted = "/dexterr-bank-proof-submitted";



export const ROUTE_PAN_VERIFICATION = "/dexterr-pan";
export const ROUTE_HOLD_INVESTMENT =
  "/dexterr-investment-holding-period-question";
export const ROUTE_RESIDENTIAL_STATUS = "/dexterr-residential-status-question";
export const ROUTE_INVESTMENT_PROFILE = "/dexterr-investment-profile-question";
export const ROUTE_DEPENDED_PEOPLE = "/dexterr-financial-dependency-question";
export const ROUTE_PORT_FOLIO = "/dexterr-handle-temporary-drop-question";
export const ROUTE_KYC_HOME_PAGE = "/dexterr-kyc-welcome";
export const ROUTE_KYC_PROCESS = "/dexterr-pan-status-kyc-valid";
export const ROUTE_KYC_NOT_DONE = "/dexterr-pan-status-kyc-invalid";
export const ROUTE_DXTER_SCANNING = "/dexterr-processing-recommended-portfolio";
export const ROUTE_DEXTER_SCANNING2 = "/dexterr-processing-bank-verification";
// export const ROUTE_DEXTER_SCANNING4 = "/dexterr-payment-status-fail";
// export const ROUTE_ACCOUNT_NUMBER_VERIFICATION = "/account-number-verification";
// export const ROUTE_IFSC_VERIFICATION = "/ifsc-code-verification";
// export const ROUTE_DEPOSITE_MONEY = "/deposite-money";
export const ROUTE_EMAIL = "/dexterr-email";
export const ROUTE_BANK = "/dexterr-bank-details";
export const ROUTE_ACCOUNT_TYPE = "/dexterr-bank-name";
export const ROUTE_NOMINEE_DETAILS = "/dexterr-add-nominee";
export const ROUTE_NOMINEE_GUARDIAN = "/dexterr-add-nominee-guardian";
export const ROUTE_NOMINEE_VERIFICATION = "/dexterr-nominee-verify-otp";
export const ROUTE_CHECKBOXES = "/dexterr-confirm-residential-status";
export const ROUTE_OCCUPATION = "/dexterr-occupation";
export const ROUTE_PLACEOF_BIRTH = "/dexterr-place-of-birth";
// export const ROUTE_Email1 = "/email1";
// export const ROUTE_PERSONAL_DETAILS = "/personal-details";
export const ROUTE_NOMINEE_SENDOTP = "/dexterr-nominee-send-otp";
// export const ROUTE_CAPTURE_PHOTO = "/dexterr-capture-photo";
// export const ROUTE_CAPTURE_Sign = "/dexterr-capture-signature";
// export const ROUTE_CAPTURE_Location = " /dexterr-capture-location";
export const ROUTE_PAYMENT_GATEWAY = "/dexterr-payment-gateway-redirection";

// export const ROUTE_PORT_FOLIO_SCREEN = "/select-portfolio";
export const ROUTE_UPDATED_PORT_FOLIO_SCREEN = "/dexterr-recommended-portfolio";
export const ROUTE_Purchase_One_Time = "/dexterr-purchase";
export const ROUTE_Purchase_CONFRIMATION_ = "/dexterr-confirm-purchase";
// export const ROUTE_PURCHASE_SENDOTP = "/dexterr-purchase-send-otp";
export const ROUTE_PURCHASE_OTP_CONFRIMATION_ = "/dexterr-purchase-verify-otp";

export const Gender_Dob_Verification = "/dexterr-dob";
export const Address_Verification = "/dexterr-address";
export const Pincode_Verification = "/dexterr-pincode";
export const ROUTE_BLANK_TEXT_SCREEN = "/iin-confirmation";
export const ROUTE_CUSTOMER_SUPPORT_SCREEN = "/dexterr-client-support";
export const ROUTE_IIN_DEACTIVATED_SCREEN = "/dexterr-iin-deactivated";
export const ROUTE_FATCA_CONFIRMATION = "/dexterr-fatca-confirmation";
export const ROUTE_FATCA_Failed = "/dexterr-fatca-failed";
export const ROUTE_SIP_Confirmation_Link = "/dexterr-sip-confirmation";
export const ROUTE_BANK_MSG_SCREEN = "/dexterr-bank-verification";
export const ROUTE_AUDIO_HIGHLIGHT = "/dexterr-audio-highlight";
export const ROUTE_NSE_CONFIRMATION_WAITING =
  "/dexterr-iin-confirmation-pending";
export const ROUTE_ACCOUNT_CONFLICT_MESSAGE =
  "/dexterr-bank-account-conflict";
  export const ROUTE_NRI_TAXID_NUMBER = "/dexterr-tax-id-number-nri";
  export const ROUTE_NRI_Address = "/dexterr-address-nri";
  export const ROUTE_NRI_Pincode = "/dexterr-pincode-nri";
  export const ROUTE_NRI_TaxResidency = "/dexterr-tax-residency-nri";


const RouterSetUp = () => {
  return (
    <Suspense fallback={<div>loading...</div>}>
      <Routes>
        <Route path="/" element={<WelcomePage />} />

        {/* <Route path="/" element={<Navigate to="/app" replace />} /> */}
        {/* <Route path="/app" element={<WelcomePage />} /> */}


        <Route path="/dexterr-welcome" element={<WelcomeScreen />} />
        {/* <Route path="/dexterr-audio-highlight" element={<AudioHighlight />} /> */}

        <Route element={<Lauyout />}>
          <Route path={Dexter_Splash2} element={<SecondSplash />} />
          <Route path={Dexter_Splash3} element={<ThirdSplash />} />
          <Route path={Dexter_Splash4} element={<FourSplash />} />
          <Route path={ROUTE_MOBILE_VERIFICATION} element={<PhoneNumber />} />
          <Route path={ROUTE_OTP_VERIFICATION} element={<VerifyOtp />} />
          {/* <Route path={ROUTE_AUDIO_HIGHLIGHT} element={<AudioHighlight />} /> */}
          <Route path={ROUTE_DEXTER_SCANNING3} element={<DextersScanning3 />} />
          <Route path={ROUTE_NRI_TAXID_NUMBER} element={<TaxIdNumber/>}/>
          <Route path={ROUTE_NRI_Address} element={<AddesssNRI/>}/>
          <Route path={ROUTE_NRI_Pincode} element={<PincodeNRI/>}/>
          <Route path={ROUTE_NRI_TaxResidency} element={<TaxResidencyNRI/>}/>
          <Route path={Pincode_Verification} element={<StatePincode />} />
          <Route path={ROUTE_Bank_Proof_Submitted} element={<BankProofSubmitted />} />
          <Route path={ROUTE_DXTER_SCANNING} element={<DextersScanning />} />
        
          {/*Public screens */}
          <Route path={ROUTE_EMAIL} element={<Email />} />
          <Route
            path={ROUTE_Dexterr_Ach_Emandate_Status}
            element={<AchEmandateStatus />}
          />
          <Route
            path={ROUTE_NSE_CONFIRMATION_WAITING}
            element={<NSeConfirmationWaiting />}
          />
          <Route
            path={ROUTE_ACCOUNT_CONFLICT_MESSAGE}
            element={<Account_Conflict_Message />}
          />
           <Route path={ROUTE_KYC_NOT_DONE} element={<KycRejected />} />
           <Route path={ROUTE_CHECKBOXES} element={<Checkboxes />} />
           <Route
              path={ROUTE_BANK_MSG_SCREEN}
              element={<BankMessagescreen />}
            />
          {/*Private screens */}
          <Route element={<ProtectedLayout />}>
          <Route
              path={ROUTE_UPLOAD_CANCELLED_CHEQUE}
              element={<CancelledCheque />}
            />
            
            <Route path={ROUTE_ACCOUNT_TYPE} element={<AccountType />} />
            <Route path={Address_Verification} element={<AddressLine />} />
            <Route
              path={ROUTE_BANK_MSG_SCREEN}
              element={<BankMessagescreen />}
            />
            <Route path={ROUTE_KYC_PROCESS} element={<KycProcess />} />

            <Route
              path={ROUTE_SIP_Confirmation_Link}
              element={<SIPConfirmationLink />}
            />
              <Route path={Gender_Dob_Verification} element={<GenderDob />} />
            <Route
              path={ROUTE_PURCHASE_OTP_CONFRIMATION_}
              element={<PurchaseVerifyOtp />}
            />
            <Route
              path={ROUTE_FATCA_CONFIRMATION}
              element={<FATCAConfirmation />}
            />
            <Route path={Address_Verification} element={<AddressLine />} />
            <Route path={ROUTE_PAN_VERIFICATION} element={<PanNumber />} />
            <Route path={ROUTE_HOLD_INVESTMENT} element={<HoldInvestment />} />

            <Route
              path={ROUTE_INVESTMENT_PROFILE}
              element={<InvesmentProfile />}
            />
            <Route
              path={ROUTE_DEPENDED_PEOPLE}
              element={<FinanciallyDepended />}
            />
            <Route path={ROUTE_PORT_FOLIO} element={<Portfolio />} />
            <Route path={ROUTE_KYC_HOME_PAGE} element={<StartKycHome />} />
            {/* <Route path={ROUTE_KYC_NOT_DONE} element={<KycRejected />} /> */}
            
            <Route
              path={ROUTE_DEXTER_SCANNING2}
              element={<DextersScanning2 />}
            />
            {/* <Route
              path={ROUTE_DEXTER_SCANNING4}
              element={<DextersScanning4 />}
            /> */}
            {/* <Route
              path={ROUTE_ACCOUNT_NUMBER_VERIFICATION}
              element={<AccountNo />}
            /> */}
            {/* <Route path={ROUTE_IFSC_VERIFICATION} element={<IfscCode />} /> */}
            {/* <Route path={ROUTE_DEPOSITE_MONEY} element={<DepositeMoney />} /> */}
            <Route path={ROUTE_EMAIL} element={<Email />} />
            <Route path={ROUTE_BANK} element={<Bank />} />
            <Route
              path={ROUTE_NOMINEE_GUARDIAN}
              element={<NomineeGuardian />}
            />
            <Route
              path={ROUTE_NOMINEE_VERIFICATION}
              element={<NomineeVerification />}
            />
            <Route
              path={ROUTE_UPDATED_PORT_FOLIO_SCREEN}
              element={<UpdatedPortFolio />}
            />
            <Route path={ROUTE_CHECKBOXES} element={<Checkboxes />} />
            <Route path={ROUTE_PLACEOF_BIRTH} element={<PlaceofBirth />} />
            <Route path={ROUTE_ACCOUNT_TYPE} element={<AccountType />} />
            <Route path={ROUTE_OCCUPATION} element={<Occupation />} />
            {/* <Route path={ROUTE_Email1} element={<Email1 />} /> */}
            {/* <Route path={ROUTE_CAPTURE_PHOTO} element={<CapturePhoto />} />
            <Route path={ROUTE_CAPTURE_Sign} element={<CaptureSignature />} />
            <Route
              path={ROUTE_CAPTURE_Location}
              element={<CaptureLocation />}
            /> */}
            {/* <Route
              path={ROUTE_PERSONAL_DETAILS}
              element={<PersonalDetails />}
            /> */}
            {/* <Route
              path={ROUTE_PORT_FOLIO_SCREEN}
              element={<RecommendedPortfolios />}
            /> */}
            
            <Route
              path={ROUTE_Purchase_One_Time}
              element={<PurchaseOneTime />}
            />
            <Route
              path={ROUTE_Purchase_CONFRIMATION_}
              element={<Confirmation />}
            />
            {/* <Route
              path={ROUTE_PURCHASE_SENDOTP}
              element={<PurchasePhoneNumber />}
            /> */}

            <Route
              path={ROUTE_PAYMENT_GATEWAY}
              element={<DextersScanning5 />}
            />

            <Route
              path={ROUTE_IIN_DEACTIVATED_SCREEN}
              element={<DeactivatedScreen />}
            />
            <Route
              path={ROUTE_CUSTOMER_SUPPORT_SCREEN}
              element={<CustomerSupportScreen />}
            />
            <Route path={ROUTE_FATCA_Failed} element={<FatcaFailed />} />
            <Route path={ROUTE_BLANK_TEXT_SCREEN} element={<BlankText />} />
            <Route
              path={ROUTE_RESIDENTIAL_STATUS}
              element={<ResidentialStatus />}
            />
            <Route
              path={ROUTE_NOMINEE_SENDOTP}
              element={<NomineePhoneNumber />}
            />
            <Route path={ROUTE_NOMINEE_DETAILS} element={<NomineeDetails />} />
          </Route>
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default RouterSetUp;
